import { useTranslation } from 'react-i18next'
import { playlistApi } from '@api/swagger'
import { useAppSnackbar } from '../useAppSnackbar'
import useLoadingContext from '../useLoadingContext'
import { useLoadingIds } from '../useLoadingIds'

export const useDeletePlaylist = ({
  onSuccess,
}: {
  onSuccess?: () => void
}): {
  deletePlaylist: (opts?: { playlistKey?: number }) => void
} => {
  const { t } = useTranslation()
  const { handleError, handleMessage } = useAppSnackbar()

  const {
    Playlist: { deletePlaylist: deletePlaylistLoadingId },
  } = useLoadingIds()

  const defaultErrorMessage = t(
    'Playlist.UseDeletePlaylist.Actions.DeletePlaylistFailure',
    'An unknown error occurred requesting to delete Playlist.'
  )

  const deletePlaylist = async (opts?: { playlistKey?: number }) => {
    if (!opts?.playlistKey) return

    try {
      await playlistApi.deletePlaylist({ playlistKey: opts.playlistKey })

      handleMessage(
        t(
          'Playlist.UseDeletePlaylist.Actions.DeletePlaylistSuccess',
          'Playlist has successfully been deleted.'
        )
      )
      onSuccess?.()
    } catch (error) {
      await handleError(error, defaultErrorMessage)
    }
  }

  const { triggerFetch } = useLoadingContext({
    asyncFunction: deletePlaylist,
    loadingId: deletePlaylistLoadingId,
  })

  return { deletePlaylist: triggerFetch }
}
